import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MOCK_CHANNELS, CHANNEL_ORDER, Channel } from "./channels-mock";
import "../messages/TicketPage.css";

// Channels menusundeki Portal / Email / Widget / WhatsApp / Telegram ogeleri
// buraya yonlenir; path'in son parcasi acilacak kanali belirler.
function slugFromPath(pathname: string): string {
    const last = pathname.split("/").filter(Boolean).pop() || "portal";
    return CHANNEL_ORDER.includes(last) ? last : "portal";
}

export default function ChannelsPage() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    // Aktif kanal dogrudan URL'den turetilir; hangi kanalin acilacagi sol menuden gelir.
    const slug = slugFromPath(pathname);

    const channel: Channel = MOCK_CHANNELS[slug] ?? MOCK_CHANNELS.portal;

    return (
        <div className="ticket-page-root flex flex-col h-full w-full" style={{ paddingBottom: 30 }}>
            {/* Secili kanal karti — hangi kanal acilacagi sol menuden (route) belirlenir */}
            <div className="flex-1 min-h-0" style={{ overflowY: "auto", padding: 20, color: "var(--base-text-color)" }}>
                <div style={{ maxWidth: 720 }}>
                    {/* Baslik */}
                    <div className="flex items-center gap-3" style={{ marginBottom: 16 }}>
                        <div className="flex items-center justify-center shrink-0" style={{ width: 48, height: 48, borderRadius: 10, background: "var(--accent-color, #6366F1)", color: "#fff", fontSize: 20 }}>
                            <i className={channel.icon} />
                        </div>
                        <div className="min-w-0">
                            <div className="font-semibold" style={{ fontSize: 18 }}>{channel.name}</div>
                            <div className="text-xs" style={{ color: "var(--subtitle-text-color)" }}>{channel.description}</div>
                        </div>
                        <span
                            style={{
                                marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 6,
                                background: channel.connected ? "#10B9811f" : "#9CA3AF1f",
                                color: channel.connected ? "#10B981" : "#9CA3AF",
                                fontWeight: 600, fontSize: 12, padding: "4px 12px", borderRadius: 999, whiteSpace: "nowrap",
                            }}
                        >
                            <span style={{ width: 7, height: 7, borderRadius: "50%", background: channel.connected ? "#10B981" : "#9CA3AF" }} />
                            {channel.connected ? t("connected") : t("notConnected")}
                        </span>
                    </div>

                    {/* Istatistik */}
                    {channel.connected && (
                        <div className="grid grid-cols-2 gap-3" style={{ marginBottom: 16 }}>
                            <div style={{ background: "var(--base-bg)", border: "1px solid var(--border-color)", borderRadius: 10, padding: "12px 14px" }}>
                                <div style={{ fontSize: 22, fontWeight: 700, color: "#F97316" }}>{channel.openTickets}</div>
                                <div className="text-xs" style={{ color: "var(--subtitle-text-color)" }}>{t("openTickets")}</div>
                            </div>
                            <div style={{ background: "var(--base-bg)", border: "1px solid var(--border-color)", borderRadius: 10, padding: "12px 14px" }}>
                                <div style={{ fontSize: 22, fontWeight: 700, color: "#10B981" }}>{t("active")}</div>
                                <div className="text-xs" style={{ color: "var(--subtitle-text-color)" }}>{t("status")}</div>
                            </div>
                        </div>
                    )}

                    {/* Ayarlar */}
                    <div className="text-xs font-semibold uppercase" style={{ letterSpacing: "0.04em", color: "var(--subtitle-text-color)", marginBottom: 6 }}>
                        {t("configuration")}
                    </div>
                    <div style={{ background: "var(--base-bg)", border: "1px solid var(--border-color)", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
                        {channel.settings.map((s, i) => (
                            <div key={s.label}
                                className="flex items-center justify-between gap-3"
                                style={{ padding: "10px 14px", borderBottom: i === channel.settings.length - 1 ? "none" : "1px solid var(--border-color)" }}
                            >
                                <span className="text-xs shrink-0" style={{ color: "var(--subtitle-text-color)" }}>{s.label}</span>
                                <span className="text-sm truncate" style={{ textAlign: "right" }}>{s.value}</span>
                            </div>
                        ))}
                    </div>

                    <button
                        type="button"
                        className="dx-button dx-button-mode-contained dx-button-default"
                        style={{ padding: "8px 16px", borderRadius: 8, fontWeight: 600 }}
                    >
                        {channel.connected ? t("manage") : t("connect")}
                    </button>
                </div>
            </div>
        </div>
    );
}
